// Pad 2 digits
export function pad2(n) {
  return String(n).padStart(2, "0");
}

// Parse ISO local (yyyy-MM-ddTHH:mm[:ss]) -> Date (local)
export function parseIsoLocal(s) {
  if (!s) return null;
  if (s instanceof Date) return s;
  const m = String(s).match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/
  );
  if (!m) return null;
  const [, y, M, d, h, mi, se = "0"] = m;
  return new Date(+y, +M - 1, +d, +h, +mi, +se);
}

export function formatDate(s) {
  const d = parseIsoLocal(s);
  if (!d) return "-";
  return `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()}`;
}

export function formatDateTime(s) {
  const d = parseIsoLocal(s);
  if (!d) return "-";
  return `${pad2(d.getDate())}/${pad2(
    d.getMonth() + 1
  )}/${d.getFullYear()} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

// Chuẩn hoá datetime-local -> "yyyy-MM-ddTHH:mm:ss"
export function normalizeDateTimeLocalForApi(input) {
  if (!input) return null;
  const d = new Date(input);
  if (isNaN(d)) return null;
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 19);
}
